<template>
  <div id=findPass>
    <div class="logintitle">
      <img class="logoimg" src="/static/img/logo.png">
    </div>
    <div class="inputcont">
      <img class="fl headtext" src="/static/img/pwd.png">
      <input placeholder="请输入6-12位密码" v-model="password" class="text" type="password">
    </div>
    <div class="inputcont">
      <div class="wd100"> 
        <img class="fl headtext" src="/static/img/yzm.png">
        <input placeholder="请输入验证码" v-model="mobileCode" class="text wd65" type="text">
        <button class="fr regcodebtn" @click="getCode()" v-bind:disabled="flag">{{codeValue}}</button>
      </div>
    </div>
    <div class="loginbtdiv"><mt-button class="login-btn" size="large" type="primary" @click="finish()">完成注册</mt-button>
    </div>
  </div>
</template>

<script>
import { Toast } from 'mint-ui';
import cregtop from '@/components/regtop2';
export default {
  data () {
    return {
      password:'',
      mobileCode:'',
      isPass: 'true',
      inputType: 'password',
      count: 60,
      codeValue:'获取验证码',
      flag: false,
      outTimer:''
    }
  },
  methods: {
    finish: function(){
        var error = /^(\w){6,20}$/;
        if(!error.test(this.password)){
            this.$toast('请输入6-12位密码');
            return;
        }
        if (this.password == null || this.password == '') {
          this.$toast("请输入验证码");
          return;
        }
        this.$http.post(
            domain("_regCodeUrl"),
            {
              'loginCode':this.$route.query.mobile,
              'code':this.mobileCode,
              'password':$.md5(this.password)
            },
            {emulateJSON: true}
        )
        .then(function(response){  //接口返回数据
            if(response.body.code == '0'){
                this.$router.push('/main');
            }else if(response.body.code == '10'){
                this.$toast('帐号已注册');
            }else{
                this.$toast('验证码错误');
            }
            },function(error){
        })
    },
    getCode:function(){
       this.$http.post(
            domain("_getyzmUrl"),
            {
              'mobile':this.$route.query.mobile,
              'mobileType':12  
            },
            {emulateJSON: true}
        )
        .then(function(response){  //接口返回数据
            if(response.body.code == '0'){
                this.$toast('验证码已发送,请查收');
                this.settime();
            }else{
                this.$toast('获取验证码失败,请稍后重试');
            }
            },function(error){
        })
    },
    settime:function(){
       var that = this;
       if (this.count == 0) { 
          this.count = 60;
          this.flag = false;
          this.codeValue = '获取验证码';
          if(this.outTimer != null){
            this.outTimer = null;
            return;
          }
       }
       this.flag = true;
       this.count--;
       this.codeValue = "重新发送(" + this.count + "s)";
       this.outTimer = setTimeout(function() {that.settime()},1000);
    }
  },
  components:{
    cregtop
  }
}
</script>
<style>
.headtext{
    position: absolute;
    top: 15px;
    left:30px;
}
.inputcont input{
    padding-left:50px; 
}
.inputcont{
    position: relative;
    padding: 0 10px;
    margin-bottom:25px;
}
.spwd{
    position: absolute;
    left: 100%;
    margin-left: -40px;
    top: 20px;
}
.inputcont img{
  width: 15px;
}
.loginbtdiv{
  padding: 0 10px;
}
.bottomlogin{
  margin-top: 10px;
  padding: 0 12px;
}
.bottomlogin a{
  color: #7d7d7d;
}
.wd100{
  width: 100%;
}
.wd65{
  width: 57%;
}
.regcodebtn{
  font-size: 18px;
  cursor:pointer;
  height:50px;
  line-height: 50px;
  border:#e5e5e5 solid 1px;
  background-color: #ffffff;
  border-radius: 4px;
  -ms-border-radius: 4px;
  -moz-border-radius: 4px;
  -o-border-radius: 4px;
  -webkit-border-radius: 4px;
  color: #7d7d7d;
  width:40%;
}
</style>



// WEBPACK FOOTER //
// src/module/register/RegPass.vue